exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".resize-about-high___3id4B {\n  height: 720px !important;\n}\n.resize-about-mobile___1KrAk {\n  height: auto !important;\n}\n.about-regular___18mMX {\n  overflow-x: scroll;\n}\n", "", {"version":3,"sources":["/causefundraisernodeweb-ci-1233/workspace/causefundraisernodeweb-ci-1233/public/js/components/about.less"],"names":[],"mappings":"AAAA;EACE,yBAAyB;CAC1B;AACD;EACE,wBAAwB;CACzB;AACD;EACE,mBAAmB;CACpB","file":"about.less","sourcesContent":[".resize-about-high {\n  height: 720px !important;\n}\n.resize-about-mobile {\n  height: auto !important;\n}\n.about-regular {\n  overflow-x: scroll;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"resize-about-high": "resize-about-high___3id4B",
	"resize-about-mobile": "resize-about-mobile___1KrAk",
	"about-regular": "about-regular___18mMX"
};